import { useEffect, useState } from "react";
import abbreviateBigNumber from "src/helpers/abbreviateBigNumber";
import { enumNever } from "src/shared/helpers/generalHelpers";
import GatheringPreviewPopUpDisplay from "../../GatheringPreviewPopUpDisplay";
import useGatheringInfoFullPublic from "../hooks/useGatheringInfoFullPublic";
import { useGatheringPublicFullStore } from "../hooks/useGatheringPublicFullStore";

const GatheringPublicFullPopUp = () => {
	const gatheringId = useGatheringPublicFullStore((state) => state.gatheringId);
	const popUpVariant = useGatheringPublicFullStore((state) => state.popUpVariant);
	const setPopUpVariant = useGatheringPublicFullStore((state) => state.setPopUpVariant);
	const handleJoinGathering = useGatheringPublicFullStore((state) => state.handleJoinGathering);
	const joinLoading = useGatheringPublicFullStore((state) => state.joinLoading);

	const { gathering } = useGatheringInfoFullPublic(gatheringId);
	const [curText, setCurText] = useState<{
		title: string;
		description: string;
	} | null>(null);

	useEffect(() => {
		if (popUpVariant) {
			const gatheringName = gathering?.name;
			const numParticipants = gathering?.numParticipants ?? 0;
			const numPhotos = gathering?.numPhotos ?? 0;
			const description = gatheringName
				? `Check out ${gatheringName}`
				: "Check out this album";

			switch (popUpVariant) {
				case "PhotoDetail":
					setCurText({
						title: "Join to see this photo",
						description,
					});
					return;
				case "VideoDetail":
					setCurText({
						title: "Join to see this video",
						description,
					});
					return;
				case "SeeViewers":
					if (numParticipants > 1) {
						setCurText({
							title: `Join to see all ${abbreviateBigNumber(numParticipants)} viewers`,
							description,
						});
					} else {
						setCurText({
							title: "Join to see the full viewer list",
							description,
						});
					}
					return;
				case "UploadPhotos":
					setCurText({
						title: "Join to upload photos",
						description,
					});
					return;
				case "ScrollPhotos":
				case "SeePhotos":
					if (numPhotos > 3) {
						setCurText({
							title: `Join to see all ${abbreviateBigNumber(numPhotos)} photos`,
							description,
						});
					} else {
						setCurText({
							title: `Join to see all the photos`,
							description,
						});
					}
					break;
				case "FilterPhotos":
					setCurText({
						title: "Find pics of you",
						description: "Join the album to filter for photos of you",
					});
					break;
				default:
					return enumNever(popUpVariant);
			}
		}
	}, [gathering?.name, gathering?.numParticipants, gathering?.numPhotos, popUpVariant]);

	return (
		<GatheringPreviewPopUpDisplay
			popUpVariant={popUpVariant}
			setPopUpVariant={setPopUpVariant}
			curText={curText}
			setCurText={setCurText}
			joinLoading={joinLoading}
			handleJoinGathering={handleJoinGathering}
		/>
	);
};
export default GatheringPublicFullPopUp;
